export default function DropdownFilter({ column: {filterValue, setFilter, id}, data}) {
    const newFilter = event => {
        if (event.target.value === 'all') {
            setFilter(undefined);
        } else {
            setFilter(event.target.value)
        }
    }

    // const width = Math.round(0.5 * Math.max(...data.map(item => item[id].length)));

    return(
        <select onChange={newFilter} value={filterValue?filterValue:undefined} className="such-input">
            <option value='all'>---Alles---</option>
            {[...new Set (data.map(item => item[id]))]
            // .map((item, i) => {console.log('item', item, 'i', i)})
                // .map((item, i, s) => console.log('item', item, 'i', i, 's', s))
                // .filter((item, i, s) => s.lastIndexOf(item) === i)
                .sort()
                .map(value => {
                    return (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    );
                  })}
        </select>
    )
}